import styled from 'styled-components';

import {
  bgColor,
  darkGray,
  lightGray,
  textGray,
  white,
} from '../../modules/colors';
import { fonts, spacing } from '../../modules/metrics';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const InputWrapper = styled.input`
  background-color: ${white};
  border: 1px solid ${lightGray};
  border-radius: 4px;
  display: block;
  font-size: ${(props) => (props.small ? fonts.xs : fonts.sm)}px;
  color: ${darkGray};
  padding: ${(props) => (props.small ? spacing.sm : spacing.md)}px;
  ${(props) => props.measurement && `padding-right: ${spacing.xl}px;`};
  width: 100%;
  ::placeholder {
    color: ${lightGray};
    font-style: italic;
  }
  :disabled {
    opacity: 0.5;
    background-color: ${lightGray};
  }
  :read-only {
    opacity: 0.7;
  }

  ${(props) =>
    props.readOnly && `border-color: ${bgColor}; color: ${textGray};`}
`;

export const Measurement = styled.div`
  color: ${textGray};
  font-style: italic;
  font-size: ${fonts.sm}px;
  position: absolute;
  top: 9px;
  right: 8px;
`;
